import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

interface Props {
  isValid: boolean,
  message: string,
  createdAt: Date
  expiresAt: Date,
  token: string
  validatedAt: Date
}

@Injectable({
  providedIn: 'root',
})
export class TransferService {

  constructor(private http: HttpClient) {}

  getPersonByCondition(condition: string): Observable<any> {
    const url = `${environment.API_URL}/user/getPersonByCondition?condition=${condition}`;
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  
    const options = { headers: headers };
  
    return this.http.get(url, options);
  }

  get generatedToken(): string {
    const validateCode = JSON.parse(localStorage.getItem('validateCode') || '{}');
    return validateCode.token || '';
  }



  transferPoints(dni: string, quantityPoints: number): Observable<any> {
    const url = `${environment.API_URL}/Conversion/transferencia`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('token'),
      'X-Security-Token' : this.generatedToken
    });

    const body = {
      condition: dni,
      quantityPoints: quantityPoints
    };

    return this.http.post(url, body, { headers });
  }

  generateCode(): Observable<any> {
    const url = `${environment.API_URL}/SecuritySessionToken/generate-code`;
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  
    return this.http.post<any>(url, {}, { headers }).pipe(
      tap((res: any) => {
        console.log('Codigo generado:', res);
      })
    );
  }

  validateCode(code: any): Observable<any> {
    const url = `${environment.API_URL}/SecuritySessionToken/validate-code`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
    });


    return this.http.post<Props>(url, code, { headers }).pipe(
      tap(response => {
        if (response) {
          const validateCode = {
            token: response.token,
            expiresAt: response.expiresAt
          };
  
          localStorage.setItem('validateCode', JSON.stringify(validateCode));
        }
      })
    );
  }


  isBanActive(): boolean {
    const stored = localStorage.getItem('validateCode');
    if (!stored) return false;
  
    try {
      const { bandEnd } = JSON.parse(stored);
      if (!bandEnd) return false;
  
      return new Date(bandEnd) >= new Date();
    } catch {
      return false;
    }
  }


  isValidateCodeStillValid(): boolean {
    const stored = localStorage.getItem('validateCode');
    if (!stored) return false;

    try {
      const { expiresAt } = JSON.parse(stored);
      return new Date(expiresAt) > new Date();
    } catch {
      return false;
    }
  }
  

}
